export const API_KEY = "AIzaSyDT5UotGNjzeyHUKv2SH3OrnETiOx7UyA4";

export default API_KEY;
